'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import Cookies from 'js-cookie';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { getCookie } from 'hub-http/helpers/cookies';
import SignupLink from '../SignupLink';
import ErrorMessage from '../ErrorMessage';
import { NO_RECORD_ERROR } from '../ErrorMessage';
import IE11Alert from '../alerts/IE11Alert';
import { fetchLoginRequirement } from '../../actions/loginRequirementActions';
import RememberMeCheckbox from './RememberMeCheckbox';
import SubmitButton from './SubmitButton';
import EmailInputForm from './EmailInputForm';
import { extractRedirectQueryParams, trimEmail, isValidEmail } from '../../lib/LoginUtils';
import { getLoginRequirementRequestStatus } from '../../selectors/LoginRequirement';
import { RequestStates } from '../../constants/RequestStates';
import { getSignupUrl } from '../../utils/urls';
import { trackSmartLoginLoad } from '../../lib/tracker';
import { SMART_LOGIN_COOKIE } from '../../constants/SmartLogin';

const EmailEntryPage = props => {
  const dispatch = useDispatch();
  const query = parseQuery(props.location.search.substr(1));
  const redirectQueryParams = extractRedirectQueryParams(query);
  const {
    loginPortalId
  } = redirectQueryParams;
  const {
    useDark,
    allowFbSignup,
    hideSignupLink,
    signupParams,
    page_id
  } = query;
  const queryParamError = query['loginError'] || '';
  let loginRedirectUrl = redirectQueryParams.loginRedirectUrl;

  if (allowFbSignup && page_id) {
    loginRedirectUrl = `${loginRedirectUrl}&page_id=${page_id}`;
  }

  const [email, setEmail] = useState(query['email'] || '');
  const [isEmailAutofilled, setIsEmailAutofilled] = useState(false);
  const [rememberLogin, setRememberLogin] = useState(Cookies.get('prefs') === '1');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState();
  const signupUrl = getSignupUrl(signupParams, allowFbSignup, loginRedirectUrl);
  const status = useSelector(getLoginRequirementRequestStatus);
  useEffect(() => {
    if (status === RequestStates.FAILED) {
      setError(NO_RECORD_ERROR);
      setSubmitting(false);
    }
  }, [status]);

  const handleError = newError => {
    setError(newError);
    setSubmitting(false);
  };

  const onSubmit = e => {
    e.preventDefault();
    const data = {
      email,
      rememberLogin
    };
    const queryData = {
      useDark,
      loginRedirectUrl,
      allowFbSignup,
      hideSignupLink,
      signupParams,
      loginPortalId,
      pageId: page_id
    };
    data.email = trimEmail(email);
    dispatch(fetchLoginRequirement(data, props.history, queryData, handleError));
    setSubmitting(true);
  };

  useEffect(() => {
    setTimeout(() => {
      try {
        setIsEmailAutofilled(document.querySelectorAll('#username:-webkit-autofill').length > 0); // eslint-disable-next-line no-empty
      } catch (ex) {}
    }, 500); // This allows automation to hook into the page for easy login. (For example speedcurve)

    window._hubspotAutomatedLoginHook = setEmail;
  }, []);

  const isSubmittable = () => {
    const emailSatisfied = isEmailAutofilled || !!email && isValidEmail(email);
    return emailSatisfied;
  };

  const submittable = !submitting && isSubmittable(); // Send tracking request on page load

  useEffect(() => {
    const userEmail = getCookie(SMART_LOGIN_COOKIE, document.cookie);
    trackSmartLoginLoad(userEmail);
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SL_EMAIL_ENTRY_SUCCESS",
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        height: '100%'
      },
      children: [!hideSignupLink && /*#__PURE__*/_jsx(SignupLink, {
        isFbSignin: allowFbSignup,
        signupParams: signupParams,
        loginRedirectUrlQueryParam: loginRedirectUrl
      }), /*#__PURE__*/_jsxs("form", {
        id: "hs-login",
        onSubmit: onSubmit,
        children: [/*#__PURE__*/_jsx(IE11Alert, {}), /*#__PURE__*/_jsx(EmailInputForm, {
          useDark: useDark,
          onEmailChange: setEmail,
          submitting: submitting,
          email: email
        }), /*#__PURE__*/_jsx("input", {
          type: "password",
          hidden: true
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          error: error || queryParamError,
          signUpLink: signupUrl
        }), /*#__PURE__*/_jsx(RememberMeCheckbox, {
          onChange: () => setRememberLogin(!rememberLogin),
          checked: rememberLogin,
          disabled: submitting
        }), /*#__PURE__*/_jsx(SubmitButton, {
          submitting: submitting,
          disabled: !submittable
        })]
      })]
    })
  });
};

export default EmailEntryPage;